module.exports = __webpack_public_path__ + "static/places_screenshot__0000-ac10870dc87e204b067667d0eeb754f6.jpg";